// => Get job transactions
const GET_JOB_TRANSACTION = '/transactions/jobs';

export const transactionEndpoints = {
    GET_JOB_TRANSACTION,
};
